export default __webpack_public_path__ + "static/media/Ñ.a1b0f509.svg";